import Component from '../Component';

class WelcomeModel extends Component {
  constructor() {
    super();
    this.state = {};
  }
}

export default WelcomeModel;